import React from "react";
import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  FacebookIcon,
  WhatsappIcon,
  TwitterIcon,
  LinkedinIcon,
} from "react-share";

const ShareButtons = () => {

 const imageUrl="https://joymediastoragedev.blob.core.windows.net/media/012dbe7c-7105-4940-b223-a9613bd9370f.jpeg";
 const message = "Check this out!";

  return (
    <div style={{ display: "flex", gap: "10px" }}>
      <FacebookShareButton url={imageUrl} quote={message}>
        <FacebookIcon size={32} round />
      </FacebookShareButton>

      <WhatsappShareButton url={imageUrl} title={message}>
        <WhatsappIcon size={32} round />
      </WhatsappShareButton>

      <TwitterShareButton url={imageUrl} title={message}>
        <TwitterIcon size={32} round />
      </TwitterShareButton>

      <LinkedinShareButton url={imageUrl} summary={message}>
        <LinkedinIcon size={32} round />
      </LinkedinShareButton>
    </div>
  );
};

export default ShareButtons;
